<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_group')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th></th>
                </tr>
            </thead>
            <app-draggable v-model="reorderedGroups" v-bind="{ animation: 200 }" tag="tbody">
                <app-group v-for="(group, i) in reorderedGroups"
                           :key="i"
                           :index="i"
                           :vehicles="group.vehicles"
                           :group="group"
                           @destroy="destroy"
                           @removeFromGroup="removeFromGroup"
                           @reorderVehicles="reorderVehicles"/>
            </app-draggable>
        </table>
        <create-modal @setGroup="setGroup"/>
        <update-modal @setGroup="setGroup"/>
    </div>
</template>

<script>
import VehicleGroupService from '@services/vehicleGroup.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import AppGroup from './Group';
import {mapGetters} from 'vuex';
import appDraggable from 'vuedraggable';
import Vue from 'vue';

export default {
    data() {
        return {
            groups: []
        };
    },
    computed: {
        ...mapGetters(['locale']),
        reorderedGroups: {
            get() {
                return this.groups;
            },
            set(groups) {
                VehicleGroupService.reorder(groups).then(res => {
                    this.$toastr.s(this.$t(res.message));
                    this.getGroups();
                });
            }
        },
    },
    methods: {
        reorderVehicles(data) {
            const index = this.groups.findIndex(g => g.id === data.group_id);
            Vue.set(this.groups[index], 'vehicles', data.vehicles);
        },
        getGroups() {
            VehicleGroupService.groups().then(res => this.groups = res);
        },
        setGroup(group) {
            const index = this.groups.findIndex(g => g.id === group.id);
            if(index !== -1) {
                Vue.set(this.groups, index, group);
            } else {
                this.groups.push(group);
            }
        },
        removeFromGroup(data) {
            if(!window.confirm(`${this.$t('Remove from group')}?`)) {
                return false;
            }
            VehicleGroupService.removeFromGroup(data.group_id, data.vehicle_id).then(res => {
                const index = this.groups.findIndex(g => g.id === data.group_id);
                if(index !== -1) {
                    Vue.set(this.groups, index, res);
                }
                this.$toastr.s(this.$t('Removed'));
            });
        },
        destroy(groupId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            VehicleGroupService.destroy(groupId).then(res => {
                const index = this.groups.findIndex(g => g.id === groupId);
                this.groups.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal,
        appDraggable,
        AppGroup
    },
    created() {
        this.getGroups();
    },
    metaInfo() {
        return {
            title: this.$t('Vehicle groups')
        };
    }
};
</script>
